const LANDING_TEMPLATE_SKIP_BACK_ROUTE_PATTERNS = [
  /\/projects\/[^/]+\/templates(?:\/|$|\?)/,
] as const

const PROJECT_LANDING_PATH_PATTERN = /^\/projects\/[^/]+\/?$/

const ROUND_TABLE_EVENT_ENTRY_SKIP_BACK_ROUTE_PATTERNS = [
  /\/workspace\/event-passport(?:\?|$)/,
  /\/workspace\/event-program(?:\?|$)/,
  /\/workspace\/event-regulation(?:\?|$)/,
] as const

function isProjectLandingPath(url: string | null | undefined): boolean {
  if (!url) {
    return false
  }

  const path = url.split('?')[0]?.split('#')[0] ?? url
  return PROJECT_LANDING_PATH_PATTERN.test(path)
}

export function shouldSkipBackNavigation(
  backUrl: string | null | undefined,
  extraPatterns: RegExp[] = [],
): boolean {
  if (!backUrl) {
    return false
  }

  const patterns = [
    ...ROUND_TABLE_EVENT_ENTRY_SKIP_BACK_ROUTE_PATTERNS,
    ...extraPatterns,
  ]
  return patterns.some(pattern => pattern.test(backUrl))
}

export function shouldSkipLandingTemplateBackNavigation(
  backUrl: string | null | undefined,
  currentUrl: string | null | undefined,
  extraPatterns: RegExp[] = [],
): boolean {
  if (!isProjectLandingPath(currentUrl)) {
    return false
  }

  const patterns = [
    ...LANDING_TEMPLATE_SKIP_BACK_ROUTE_PATTERNS,
    ...extraPatterns,
  ]

  if (!backUrl) {
    return false
  }

  return patterns.some(pattern => pattern.test(backUrl))
}
